import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_GESCON_SEF_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterComprometimentos(fornecedorId) {
        return axiosJwt
            .get(`${api}/gescon/fornecedores/servicos/fornecedor/${fornecedorId}/comprometimentos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentosPorVencimentos(fornecedorId) {
        return axiosJwt
            .get(`${api}/gescon/fornecedores/servicos/fornecedor/${fornecedorId}/comprometimentosvencimentos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoAnexos(fornecedorId, codContrato, idComprometimento) {
        let url = `${api}/gescon/fornecedores/servicos/comprometimentos/${idComprometimento}/anexos`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoAnexosTipos() {
        let url = `${api}/gescon/fornecedores/servicos/comprometimentos/anexos/tipos`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoPorId(idComprometimento) {
        return axiosJwt
            .get(`${api}/gescon/fornecedores/servicos/comprometimentos/${idComprometimento}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirComprometimentoAnexo(anexo) {
        return axiosJwt
            .post(`${api}/gescon/fornecedores/servicos/comprometimentos/anexos`, anexo)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirComprometimentoAnexo(anexoId) {
        return axiosJwt
            .delete(`${api}/gescon/fornecedores/servicos/comprometimentos/anexos/${anexoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoAnexo(anexoId) {
        return axiosJwt
            .get(`${api}/gescon/fornecedores/servicos/comprometimentos/anexos/${anexoId}`, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    buscarFornecedores(buscar) {
        return axiosJwt
            .get(`${api}/gescon/fornecedores/servicos/fornecedores/buscar`, { buscar })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterFiltros() {
        return axiosJwt
            .get(`${api}/gescon/fornecedores/servicos/filtros`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}